import {RateBreakdown} from '@findhotel/sapi/dist/types/packages/core/src'
/**
 * Calculates the total rate for a RateBreakdown and a given tax configuration.
 * @param rate - The rate breakdown object containing base rate, taxes, and hotel fees
 * @param includeTaxes - Whether to include taxes in the calculation
 * @param includeLocalTaxes - Whether to include local taxes/hotel fees in the calculation
 * @returns The calculated total rate
 */
export const calculateTotalRate = (
  rate: RateBreakdown,
  includeTaxes: boolean,
  includeLocalTaxes: boolean
): number => {
  const baseRate = includeTaxes ? rate.base + rate.taxes : rate.base
  const totalRate = includeLocalTaxes ? baseRate + rate.hotelFees : baseRate
  return totalRate
}
